package com.milta.core.localization.translations.ro

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Anulare",
    confirm = "Confirmă",
    save = "Salvează",
    delete = "Șterge",
    back = "Înapoi",
    loading = "Se încarcă…",
    retry = "Reîncearcă",
    language = "Limbă",
    welcomeTitle = "Bun venit la Milta",
    welcomeSubtitle = "Asistentul dvs. inteligent de livrare",
    alreadyHaveAccount = "Am deja un cont",
    createAccount = "Creează un cont",
    continueWithGoogle = "Continuă cu Google",
    continueWithApple = "Continuă cu Apple",
    oauthErrorGeneric = "A apărut o eroare la conectare. Încercați din nou.",
    oauthAppleWebComingSoon = "Conectarea cu Apple va fi disponibilă în curând pe web.",
    oauthDriverAccountNotAllowedOnWeb = "Conturile de șofer nu pot accesa tabloul de bord web. Conectați-vă din aplicația mobilă.",
    oauthAccountNotFoundOnWeb = "Nu a fost găsit niciun cont Milta pentru acest cont Google.",
    errorOffline = "Fără conexiune la internet.",
    navTourneesDuJour = "Curse de azi",
    navAjouterUneTournee = "Adaugă o cursă",
    navHistoriqueDesPreuves = "Istoric livrări",
    navParametres = "Setări",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Nicio livrare încă",
    noDeliveriesYetSubtitle = "Atingeți „Adăugați livrări” pentru a adăuga",
    optimizationUnavailableExplanation = "Doriți să creați cursa fără optimizare, sau să reîncercați?",
    createWithoutOptimizationAction = "Creează fără optimizare",
    gpsAppSheetTitle = "Alege o aplicație de navigație",
    addressSearchingLabel = "Se caută…",
)
